import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    displayId: String
  }

  connect() {
    // Update display on connect
    this.updateDisplay()
  }

  updateDisplay() {
    const input = this.element
    const display = document.getElementById(this.displayIdValue)
    
    if (!display) return
    
    if (input.value) {
      // Create date in local timezone to avoid off-by-one issues
      const date = new Date(input.value + 'T00:00:00')
      display.textContent = date.getDate()
    } else {
      const today = new Date()
      display.textContent = today.getDate()
      
      // Also update the input value
      input.value = today.toISOString().split('T')[0]
    }
  }
} 